const MoveDecision = require('./MoveDecision');
const BattleCalc = require('../../BattleCalc');

const MoveTowardsDecision = function (actor, battleState) {
  const node = new MoveDecision(actor, battleState);

  node.getTargetTile = function (move_towards_input, candidate_tiles) {
    // filter for those closest to the target
    let closest_dist = Infinity;
    for (const tile of candidate_tiles) {
      const dist = BattleCalc.boardDistance(tile, move_towards_input);
      if (dist < closest_dist) closest_dist = dist;
    }
    let final_candidate_tiles = candidate_tiles.filter(
      (tile) =>
        BattleCalc.boardDistance(tile, move_towards_input) === closest_dist
    );

    // filter again for closest to actor
    let closest_to_actor_dist = Infinity;
    for (const tile of final_candidate_tiles) {
      const dist = BattleCalc.boardDistance(tile, actor);
      if (dist < closest_to_actor_dist) closest_to_actor_dist = dist;
    }
    final_candidate_tiles = final_candidate_tiles.filter(
      (tile) => BattleCalc.boardDistance(tile, actor) === closest_to_actor_dist
    );

    return final_candidate_tiles[
      Math.floor(Math.random() * final_candidate_tiles.length)
    ];
  };

  return node;
};
module.exports = MoveTowardsDecision;
